(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  // ── Real-time cart badge sync ─────────────────────────────────────────────
  // Shopify's cart JS re-renders the hidden #cart-icon-bubble after every cart
  // change. We watch it and mirror the new count into the custom header badge.
  const cartBubble = document.getElementById('cart-icon-bubble');
  const cartBadge  = document.getElementById('ht-cart-count');
  const cartSub    = document.getElementById('ht-cart-count-sub');

  function syncCartBadge() {
    if (!cartBubble) return;
    const countEl = cartBubble.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    const count = countEl ? parseInt(countEl.textContent.trim(), 10) || 0 : 0;

    if (cartBadge) {
      cartBadge.textContent = count < 100 ? count : '99+';
      cartBadge.classList.toggle('ht-cart-badge--hidden', count === 0);
    }
    if (cartSub) {
      cartSub.textContent = count > 0 ? count + ' item' + (count === 1 ? '' : 's') : 'Empty';
    }
  }

  if (cartBubble) {
    new MutationObserver(syncCartBadge).observe(cartBubble, { childList: true, subtree: true });
  }

  // ── Mobile drawer ─────────────────────────────────────────────────────────
  const openBtn  = document.getElementById('ht-mobile-menu-open');
  const closeBtn = document.getElementById('ht-mobile-menu-close');
  const drawer   = document.getElementById('ht-mobile-drawer');
  const overlay  = document.getElementById('ht-mobile-overlay');

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    overlay.removeAttribute('aria-hidden');
    openBtn && openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(() => drawer.focus(), 50);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    openBtn && openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (openBtn)  openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);

  // Trap focus + ESC
  drawer && drawer.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // ── Mobile accordion toggles ──────────────────────────────────────────────
  document.querySelectorAll('[data-ht-mobile-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const item = btn.closest('.ht-mobile-nav__item');
      const isExpanded = item.classList.contains('is-expanded');
      // Collapse siblings
      btn.closest('.ht-mobile-nav__list').querySelectorAll('.ht-mobile-nav__item.is-expanded').forEach(function(el) {
        el.classList.remove('is-expanded');
        el.querySelector('[data-ht-mobile-toggle]').setAttribute('aria-expanded', 'false');
      });
      if (!isExpanded) {
        item.classList.add('is-expanded');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ── Sticky Category Nav ───────────────────────────────────────────────────
  const categoryNav = document.querySelector('.ht-category-nav');
  if (categoryNav) {
    const placeholder = document.createElement('div');
    placeholder.className = 'ht-category-nav-placeholder';
    placeholder.style.display = 'none';
    categoryNav.parentNode.insertBefore(placeholder, categoryNav);

    let ticking = false;
    let navOffsetTop = 0;
    
    function updateOffset() {
      if (!categoryNav.classList.contains('is-fixed')) {
        navOffsetTop = categoryNav.getBoundingClientRect().top + window.scrollY;
        placeholder.style.height = categoryNav.offsetHeight + 'px';
      }
    }
    
    // Initial calculation
    setTimeout(updateOffset, 100);

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          if (window.scrollY >= navOffsetTop && navOffsetTop > 0) {
            categoryNav.classList.add('is-fixed');
            placeholder.style.display = 'block';
          } else {
            categoryNav.classList.remove('is-fixed');
            placeholder.style.display = 'none';
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
    
    window.addEventListener('resize', updateOffset);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
